<template>
	<div class="good-search-content">
		<div class="search-content">
			<div class="form-item">
				<div class="label yx-color-text-primary fz-14">商品名称</div>
				<div class="content">
					<el-input class="input-style" v-model="search.outerProductName" placeholder="请输入商品名称"></el-input>
				</div>
			</div>
			<div class="form-item">
				<div class="label yx-color-text-primary fz-14">商品ID</div>
				<div class="content">
					<el-input class="input-style" v-model="search.outerProductId" placeholder="请输入商品ID"></el-input>
				</div>
			</div>
			<div class="form-item">
				<div class="label yx-color-text-primary fz-14">动态类型</div>
				<div class="content">
					<el-select v-model="search.actionType">
						<el-option :label="item.label" :value="item.value" :key="index" v-for="(item, index) in DYNAMIC_COLUMNS"></el-option>
					</el-select>
				</div>
			</div>
			<div class="form-item">
				<div class="label yx-color-text-primary fz-14">创建时间</div>
				<div class="content">
					<el-date-picker
						:default-time="['00:00:00', '23:59:59']"
						@change="value => changeTimed(value)"
						class="data-picker"
						v-model="time"
						type="daterange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
					>
					</el-date-picker>
				</div>
			</div>
			<div class="form-item">
				<div class="label yx-color-text-primary fz-14">跟进人</div>
				<div class="content">
					<zs-partner-select class="follow-up-people" v-model="search['userId']"></zs-partner-select>
				</div>
			</div>
			<!--todo wzj 用组件 -->
			<div class="form-item">
				<div class="label"></div>
				<div class="content">
					<el-button type="primary" @click="submit()">搜索</el-button>
					<el-button @click="clear()">清空</el-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import ZsPartnerSelect from '@/components/zsPartnerSelect';
import { DYNAMIC_COLUMNS } from '@/utils/newDataMap/shopManage.js';
export default {
	components: {
		ZsPartnerSelect,
	},
	data() {
		return {
			search: {
				outerProductName: '', //商品名称筛选
				outerProductId: '', //商品ID筛选
				addTimeStart: '', //商品流转时间开始
				userId: '', //跟进人
				actionType: 0, // 流转类型 0 全部 1 认领商品 2 取消认领商品
			},
			time: '', //时间
			DYNAMIC_COLUMNS, // 流转类型 option
		};
	},
	methods: {
		// 清空
		clear() {
			this.search = {
				outerProductName: '', //商品名称筛选
				outerProductId: '', //商品ID筛选
				addTimeStart: '', //商品流转时间开始
				addTimeEnd: '', // 商品流转结束时间
				userId: '', //跟进人
				actionType: 0, // 流转类型 0 全部 1 认领商品 2 取消认领商品
			};
			this.time = '';
			this.submit();
		},
		// 搜索
		submit() {
			this.$emit('search', this.search);
		},
		changeTimed(value){
			const [start, end] = value || [];
			this.search.addTimeStart = start ? start.getTime() / 1000 : '';
			this.search.addTimeEnd = end ? end.getTime() / 1000 : '';
		}
	},
};
</script>
<style lang="less" scoped>
.search-content {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
}
.form-item {
	display: flex;
	align-items: center;
	margin-right: 28px;
	margin-bottom: 16px;
	.label {
		min-width: 60px;
		text-align: left;
		margin-right: 12px;
	}
	.input-style {
		width: 216px;
	}
	.data-picker {
		width: 216px;
	}
}
.form-item:nth-child(3n) {
	margin-right: 0px;
}
.follow-up-people {
	width: 216px;
}
</style>
